export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_barbecue-4f14ecddd44ccb75b782390475e527eb.jpg";